import instance from '../lib/axios'

const PATH = '/contacts'

export const getContacts = (params: {start: number; perPage: number; search?: string}) =>
  instance({method: 'get', url: PATH, params})

export const getContact = (id: number | string) => instance({method: 'get', url: PATH + '/' + id})

export const patchContact = (
  id: number | string,
  data: {
    name?: string
    nickname?: string
    password?: string
  }
) => instance({method: 'patch', url: PATH + '/' + id, data})

export const deleteContacts = (id: number | string) => instance({method: 'delete', url: PATH + '/' + id})
